import React from "react";
import { JsonSchemaForm } from "react-jsonschema-form";

import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
} from "react-admin";

import { FormToolbar } from "../../common/FormToolbar";
import { Authorizer } from "../../common/Authorizer";
export const ActivityCreate = (props) => {
  
  let propsObj = Authorizer(props,"Create"); 
  let tenantID = localStorage.getItem("TenantID");
  let facilityID = localStorage.getItem("FacilityID");
  let userID = localStorage.getItem("userId");
  let defaultValues = {
  //  tenantId: tenantID,
    // facilityId: facilityID,
    
    createdDate: new Date(),
    createdBy: userID,
    isActive: true
  };
  return (
    <Create {...propsObj}> 
      <SimpleForm redirect="list" initialValues={defaultValues}
        toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined" >
<ReferenceInput source="stateId" reference="states"  validate={[required()]} fullWidth={true} link={false} label="State" perPage={2000} sort={{ field: 'name', order: 'ASC' }}>
                        <SelectInput source="name" />
                    </ReferenceInput>
       <TextInput source="code" label="Code"  fullWidth={true}  validate={[required()]}/>
       <TextInput source="name" label="Name"  fullWidth={true}  validate={[required()]}/> 
        <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true} />
      </SimpleForm>
    </Create>
  );
};
